import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { BoundedNameValidationError } from "../enums/BoundedNameValidationError";
import { EMPTY_CHARACTER } from "@pulse/shared-components";
import { BoundedName } from "@pulse/pulse-rpcs/lib/types/boundedName";

const validateAndGetBoundedNameValidationError = (
  templateName: string,
): BoundedNameValidationError | undefined => {
  if (templateName.length < BoundedName.constraints.name.minSize) {
    return BoundedNameValidationError.MinSize;
  }

  if (templateName.length > BoundedName.constraints.name.maxSize) {
    return BoundedNameValidationError.MaxSize;
  }
};

export const BoundedNameModel = types
  .model("BoundedNameModel", {
    name: types.string,
    validationError: types.maybe(
      types.enumeration(
        "BoundedNameValidationError",
        Object.values(BoundedNameValidationError),
      ),
    ),
  })
  .views((store) => ({
    get rpcObject(): BoundedName {
      return new BoundedName(store.name);
    },
  }))
  .actions((store) => ({
    setName: (name: SnapshotIn<typeof store>["name"]): void => {
      store.validationError = validateAndGetBoundedNameValidationError(name);
      store.name = name;
    },
  }));

export const createBoundedNameModel = (
  boundedName?: SnapshotIn<typeof BoundedNameModel>,
): Instance<typeof BoundedNameModel> =>
  BoundedNameModel.create(boundedName ?? { name: EMPTY_CHARACTER });
